import { useField } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Social from './Social';

const SocialContainer = (props) => {
  const { t } = useTranslation();
  const [{ value: organization }] = useField('organization');
  return (
    (!organization ||
      !organization.forceSSO ||
      organization.allowGoogleSSO ||
      organization.allowMicrosoftSSO) && (
      <Social organization={organization} t={t} {...props} />
    )
  );
};

export default SocialContainer;
